import { render, staticRenderFns } from "./TableDetailFiles.vue?vue&type=template&id=11489ecf&"
import script from "./TableDetailFiles.vue?vue&type=script&lang=ts&"
export * from "./TableDetailFiles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports